import reduce from 'lodash/reduce'
import upperFirst from 'lodash/upperFirst'

export const updateObject = (prevObject, newValues) => (
  Object.assign({}, prevObject, newValues)
)

export const updateDeepKey = (rootData, val, ...keys) => keys.reduce(({ parentData, updater }, currentKey) => {
  if (currentKey === keys[keys.length - 1]) {
    return updater(Object.assign({}, parentData, { [currentKey]: val }));
  }
  return {
    updater: (newData) => updater(Object.assign({}, parentData, { [currentKey]: newData })),
    parentData: parentData[currentKey],
  };
}, {
  parentData: rootData,
  updater: (data) => (data),
});

export const convertNumericValue = (obj, prefix) => {
  return reduce(obj, (result, val, key) => ({
    ...result,
    [prefix ? `${prefix}${upperFirst(key)}` : prefix]: (
      isFinite(val) ? parseFloat(val) || '' : val
    ),
  }), {})
}



// WEBPACK FOOTER //
// ./src/helpers/objectHelpers.js